/**
 * Rich text block list normalization — used by registry migration (no registry import).
 */

import {
  sanitizePlainTextNodeContent,
  sanitizeRichTextContent,
} from '@/lib/scroll-preview'
import {
  getEmbedBlockType,
  getEmbedData,
  isRichTextTextNode,
  newRichTextId,
  RICHTEXT_EMBED_EXCLUDED,
} from './richtext-node-utils'

/**
 * Ensure row ids are unique inside a section (legacy seeds reused rt-1, rt-2, …).
 */
export function normalizeRichTextBlocks(blocks, { scopeId } = {}) {
  if (!Array.isArray(blocks)) return []
  const seen = new Set()
  return blocks
    .map((node) => {
      if (!node || typeof node !== 'object') return null
      let id = node.id ?? newRichTextId()
      if (seen.has(id)) {
        id = scopeId ? `${scopeId}-${id}-${newRichTextId()}` : newRichTextId()
      }
      seen.add(id)

      if (isRichTextTextNode(node)) {
        const raw =
          typeof node.content === 'string' ? node.content : ''
        const sanitized =
          node.type === 'h3' || node.type === 'blockquote'
            ? sanitizePlainTextNodeContent(raw)
            : sanitizeRichTextContent(raw)
        return {
          id,
          type: node.type,
          content: sanitized,
        }
      }

      const blockType = getEmbedBlockType(node)
      if (!blockType || RICHTEXT_EMBED_EXCLUDED.has(blockType)) return null

      return {
        id,
        type: 'embed',
        blockType,
        data: getEmbedData(node),
      }
    })
    .filter(Boolean)
}
